import React from "react";
import { data } from "../../data";
import { Link } from "react-router";

interface ISubFooterComponentProps { }

export const SubFooterComponent: React.FC<ISubFooterComponentProps> = (
    props: ISubFooterComponentProps
) => {
    return (
        <div className="container">
            <div className="copyright">
                <span>Copyright © 2025</span>{" "}
                <strong className="px-1 sitename">
                    {data.italent.name.short}.
                </strong>{" "}
                <span>All Rights Reserved</span>{" • "}
                <Link
                    to="/terms-and-conditions"
                >
                    <span
                        style={{ color: "white", textDecoration: "underline", cursor: "pointer" }}
                    >Terms & Conditions</span>
                </Link>
                {" • "}
                <Link
                    to="/privacy-policy"
                >
                    <span
                        style={{ color: "white", textDecoration: "underline", cursor: "pointer" }}
                    >Privacy Policy</span>
                </Link>
            </div>
            <div className="credits">
                Made With {"❤️"} By {" "}
                <a
                    href={data.justbe.link}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "white", textDecoration: "underline" }}
                >
                    {data.justbe.name.full}
                </a>
            </div>
        </div>
    );
};
